function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
import React, { useMemo } from 'react';
import { Box, Tooltip } from '@mui/material';
import { constants } from '../constants';
/**
 * Policy resource action structure from session storage
 */
/**
 * Policy structure from session storage
 */
/**
 * Get policies from session storage
 */
export var getPoliciesFromSession = function getPoliciesFromSession() {
    try {
        var policiesStr = sessionStorage.getItem('policy');
        if (!policiesStr)
            return [];
        var parsed = JSON.parse(policiesStr);
        return Array.isArray(parsed) ? parsed : [];
    }
    catch (error) {
        console.error('Failed to parse policies from session storage:', error);
        return [];
    }
};
/**
 * Policy resource structure
 */
/**
 * Component that controls rendering/behavior of children based on user permissions
 *
 * @example
 * // Hide element when not authorized
 * <PermissionGate action="Platform:DeleteData">
 *   <Button>Delete</Button>
 * </PermissionGate>
 *
 * @example
 * // Disable element when not authorized
 * <PermissionGate action="Platform:EditData" behavior="disable">
 *   <Button>Edit</Button>
 * </PermissionGate>
 *
 * @example
 * // Grey out element when not authorized
 * <PermissionGate action="Platform:ViewData" behavior="grey" unauthorizedTooltip="You don't have permission">
 *   <Typography>Sensitive Data</Typography>
 * </PermissionGate>
 */
/**
 * Check if action is authorized based on policies
 */
var checkActionAuthorization = function checkActionAuthorization(action, policies) {
    if (!policies || policies.length === 0) {
        return false;
    }
    var hasAllowPolicy = false;
    var _iterator = _createForOfIteratorHelper(policies), _step;
    try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var policy = _step.value;
            var resourceActions = policy.resource_action || [];
            var _iterator2 = _createForOfIteratorHelper(resourceActions), _step2;
            try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var resourceAction = _step2.value;
                    var actions = resourceAction.action || [];
                    // Check if action matches exactly or via wildcard pattern
                    var isMatch = actions.some(function (policyAction) {
                        var lowerPolicyAction = policyAction.toLowerCase();
                        var lowerAction = action.toLowerCase();
                        // Exact match
                        if (lowerPolicyAction === lowerAction) {
                            return true;
                        }
                        // Wildcard match: convert "Platform:*" to regex "^platform:.*$"
                        if (lowerPolicyAction.includes('*')) {
                            var regexPattern = '^' + lowerPolicyAction.replaceAll('*', '.*') + '$';
                            var regex = new RegExp(regexPattern);
                            return regex.test(lowerAction);
                        }
                        return false;
                    });
                    if (isMatch) {
                        if (policy.effect === 'allow') {
                            hasAllowPolicy = true;
                        }
                        else if (policy.effect === 'deny') {
                            // Early return if we find a deny policy - deny always wins
                            return false;
                        }
                    }
                }
            }
            catch (err) {
                _iterator2.e(err);
            }
            finally {
                _iterator2.f();
            }
        }
    }
    catch (err) {
        _iterator.e(err);
    }
    finally {
        _iterator.f();
    }
    return hasAllowPolicy;
};
export var PermissionGate = function PermissionGate(_ref) {
    var action = _ref.action, policiesProp = _ref.policies, children = _ref.children, _ref$behavior = _ref.behavior, behavior = _ref$behavior === void 0 ? 'hide' : _ref$behavior, _ref$fallback = _ref.fallback, fallback = _ref$fallback === void 0 ? null : _ref$fallback, _ref$unauthorizedTool = _ref.unauthorizedTooltip, unauthorizedTooltip = _ref$unauthorizedTool === void 0 ? constants.permission_gate_unauthorized_tooltip : _ref$unauthorizedTool, _ref$requireAll = _ref.requireAll, requireAll = _ref$requireAll === void 0 ? true : _ref$requireAll;
    // Get policies from props or session storage
    var policies = policiesProp !== null && policiesProp !== void 0 ? policiesProp : getPoliciesFromSession();
    var authorized = useMemo(function () {
        var actions = Array.isArray(action) ? action : [action];
        if (requireAll) {
            // User must have ALL actions
            return actions.every(function (act) {
                return checkActionAuthorization(act, policies);
            });
        }
        else {
            // User needs ANY action
            return actions.some(function (act) {
                return checkActionAuthorization(act, policies);
            });
        }
    }, [action, policies, requireAll]);
    // User is authorized - render children normally
    if (authorized) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    // User is NOT authorized - apply behavior
    switch (behavior) {
        case 'hide':
            return /*#__PURE__*/ React.createElement(React.Fragment, null, fallback);
        case 'disable':
            return /*#__PURE__*/ React.createElement(Tooltip, {
                title: unauthorizedTooltip,
                arrow: true
            }, /*#__PURE__*/ React.createElement("span", null, React.Children.map(children, function (child) {
                if ( /*#__PURE__*/React.isValidElement(child)) {
                    return /*#__PURE__*/ React.cloneElement(child, {
                        disabled: true
                    });
                }
                return child;
            })));
        case 'grey':
            return /*#__PURE__*/ React.createElement(Tooltip, {
                title: unauthorizedTooltip,
                arrow: true
            }, /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    opacity: 0.4,
                    pointerEvents: 'none',
                    cursor: 'not-allowed'
                }
            }, children));
        default:
            return /*#__PURE__*/ React.createElement(React.Fragment, null, fallback);
    }
};
